module.exports = __webpack_public_path__ + "img/favorite.bc8cecb7.svg";